import clsx from 'clsx'
import type { ReactElement, ComponentPropsWithoutRef } from 'react'

import styles from './image.module.css'

interface ImageProps extends ComponentPropsWithoutRef<'img'> {
  fit?: 'contain' | 'cover'
}

export function Image({
  alt = '',
  className,
  fit = 'cover',
  src,
  ...rest
}: ImageProps): ReactElement {
  /**
   * Prevents this React error: An empty string ("") was passed
   * to the src attribute. This may cause the browser to download the
   * whole page again over the network. To fix this, either do not render
   * the element at all or pass null to src instead of an empty string.
   *
   * If an image is missing, the image should show broken visual state
   * and the alt text displayed.
   */
  const explicitSource = src && src !== '' ? src : undefined

  return (
    <img
      alt={alt}
      className={clsx(styles.image, styles[fit], className)}
      src={explicitSource}
      {...rest}
    />
  )
}
